<div class="layout-col full">
  <ng-template elderShellSlot="header"> </ng-template>
  <!-- disable static navigation -->
  <ng-template elderShellSlot="static-nav"></ng-template>

  <app-storage-node-browser class="flex" elderDataViewIframeAdapter> </app-storage-node-browser>
</div>
